import { Session } from '@supabase/supabase-js';

export type CompleteRegistrationResult = {
  success: boolean;
  activated?: boolean;
  alreadyActive?: boolean;
  user?: {
    id: string;
    name: string;
    email: string;
    role: string;
    taller_id: number | null;
  };
};

export async function completePendingRegistration(session: Session | null) {
  const token = session?.access_token;
  if (!token) return null;

  const response = await fetch('/api/auth/complete-registration', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    const message = payload && typeof payload.error === 'string'
      ? payload.error
      : 'No se pudo activar el taller.';
    throw new Error(message);
  }

  return payload as CompleteRegistrationResult;
}
